/** Wallet + theme only (inventory / marketplace pages — no NFT grid). */
import "./layout-shell.css";
import "./styles.css";

const pathForStyles = typeof window !== "undefined" ? window.location.pathname : "";
if (pathForStyles.includes("inventory")) {
  import("./inventory.css");
}
if (pathForStyles.includes("raffle")) {
  import("./raffle.css");
}
import { initComingSoonNavLinks, initMobileNav } from "./navMobile.js";
import { initThemeLamp } from "./theme.js";
import { initWalletConnect } from "./wallet/reown.js";
import { mountProdEnvBannerIfNeeded, warnStakingEnvIfIncomplete } from "./lib/env.js";

initThemeLamp();
initMobileNav();
initComingSoonNavLinks();
warnStakingEnvIfIncomplete();
mountProdEnvBannerIfNeeded();
void initWalletConnect();

const path = typeof window !== "undefined" ? window.location.pathname : "";
if (path.includes("inventory")) {
  import("./inventory-ui.js").then((m) => void m.initInventoryPage());
} else if (path.includes("playground")) {
  import("./playgroundPage.js").then((m) => void m.initPlaygroundPage());
} else if (path.includes("raffle")) {
  import("./rafflePage.js").then((m) => void m.initRafflePage());
}
